/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import { useTranslation } from "react-i18next";

import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import AutoFormDialog from "../dialogTypes/AutoFormDialog";

import defineConf from "../../config/defineConf";

function MomSysMstMaterialCreateButton ( props ) {
    const {t} = useTranslation();
    const {id, schema, refresh, onSuccess, ...others} = props;
    const [open, setOpen] = useState(false);
    
    const onOpen = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onCreateSuccess = (msg) => {
        if (onSuccess) {
            onSuccess (msg);
        }
        refresh.refresh ();
    };

    const checkShowCallback = (formData, column) => {
        if (formData.opCode === defineConf.opCode.PUR2) {
            formData.cutCode1 = null;
            formData.cutCode2 = null;

            switch(column.name) {
                case "cutCode1" : 
                case "cutCode2" : 
                    return false;

                default :
                    return true;
            }
        } else {
            switch(column.name) {
                case "cutCode1" : 
                case "cutCode2" : 
                    return true;

                default :
                    return true;
            }
        }
    }

    return (
        <>
            <CreateRecordButtonLayout id={id+"create-button"} onClick={onOpen} {...others} />
            <AutoFormDialog
                id={id+"create-dialog"}
                formId={id+"create-form"}
                title={t(`dialog.title.MomSysMstMaterial.create`)}
                schema={schema}
                initialData={undefined}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
                checkShowCallback = {checkShowCallback}
            />
        </>
    );
}

export default MomSysMstMaterialCreateButton;

